import { useTranslation } from 'react-i18next'

import { Modal } from '@/components/ui'

import ClientOrderPicker from './ClientOrderPicker'

/**
 * „Pridať platbu“ bez toho, aby operátor prišiel z konkrétnej rezervácie.
 *
 * Platba sa vždy zapisuje na objednávku (variabilný symbol), takže sa najprv
 * nájde klient a potom jeho objednávka, ktorá ešte má zostatok
 * (`ClientOrderPicker`). Samotný zápis sumy je až v `OrderModal`, ktorý sa
 * otvorí po výbere.
 */
export default function AddPaymentModal({
  onClose,
  onPicked,
}: {
  onClose: () => void
  onPicked: (ref: number, clientName: string) => void
}) {
  const { t } = useTranslation()

  return (
    <Modal open onClose={onClose} title={t('paymentsPage.add')}>
      <div className="space-y-3">
        <ClientOrderPicker onPick={onPicked} />
      </div>
    </Modal>
  )
}
